import { createAsyncThunk } from '@reduxjs/toolkit';
import { EApiStatuses } from '../../../constants';
import {IError, IPageShopifyHistoryPayload} from '../../../models/inner-models';
import {IDownloadZip, IRestorePayload, IRestoreShopifyPayload} from '../../../models/models';
import { EBackups, EPlatformNames } from '../../constants';
import { addPlatformIdentifier } from '../../functions';
import instance from '../../middlewares/api';

const getShopifyActions = createAsyncThunk(
  addPlatformIdentifier(EBackups.transferRepoData, EPlatformNames.shopify),
  async (payload: IPageShopifyHistoryPayload, thunkAPI) => {
    const entity = payload.entity.slice(0, -1);
    try {
      const response = await instance.get(`shopify/${entity}-history?page=${payload.page}&perPage=${payload.perPage}&${entity}Id=${payload.itemId}`);
      return (!response?.data?.result || response.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: response?.data?.message || 'Error on data load. Try later' }) : response.data.result;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const getShopifyBackupsDate = createAsyncThunk(
  addPlatformIdentifier(EBackups.transferAllData, EPlatformNames.shopify),
  async (_, thunkAPI) => {
    try {
      const response = await instance.get(`shopify/backup-dates`);
      return (!response?.data?.result || response.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: response?.data?.message || 'Error on data load. Try later' }) : response.data.result;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const restoreShopifyBackup = createAsyncThunk(
  addPlatformIdentifier(EBackups.restoreBackup, EPlatformNames.shopify),
  async (pageRestore: IRestoreShopifyPayload, thunkAPI) => {
    try {
      const resp = await instance.post('shopify/restore', pageRestore);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({error: resp?.data?.message || 'Error on data restore. Try later'}) : resp.data;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const restoreAllShopifyBackup = createAsyncThunk(
  addPlatformIdentifier(EBackups.restoreBackupAll, EPlatformNames.shopify),
  async (date: string, thunkAPI) => {
    try {
      const resp = await instance.post('shopify/restore-by-date', {date});
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({error: resp?.data?.message || 'Error on data restore. Try later'}) : resp.data;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const downloadShopifyZip = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadZip, EPlatformNames.shopify),
  async ({versionId,workspaceId}: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('shopify/shopify-get-zip', {workspaceVersionId:versionId,workspaceId});
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export { getShopifyActions, getShopifyBackupsDate, restoreShopifyBackup, restoreAllShopifyBackup, downloadShopifyZip };
